import type { IconConfig } from '#types/config/components/icon'

export default {
  circleRadius: 2.25,
  paths: () => [
    ['M6.25 6.25 L7.75 7.75', 'M2.5 7.5 L7.5 2.5'],
    ['M6.25 6.25 L7.75 7.75', 'M2.5 2.5 L7.5 7.5']
  ]
} satisfies IconConfig['search']
